package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.GameTableRepository

class GetTableMemberNotesUseCase(private val repository: GameTableRepository) {
    suspend operator fun invoke(tableId: String, userId: String): Result<String> =
        repository.getMemberNotes(tableId, userId)
}
